import { CheckCircleOutlined, HighlightOffOutlined } from "@mui/icons-material";
import { CustomTooltip } from "components/CustomTooltip/CustomTooltip";
import React from "react";

const RenderOnbaseMessage = (props) => {
    return (
        props.data.onbase_error_message ? <CustomTooltip title={props.data.onbase_error_message} placement="top-start" >
            <div className={props.data.onbase_confirmation.toLowerCase() === "success" ? "ehr-success" : "ehr-failure"}>
                {props.data.onbase_confirmation.toLowerCase() === "success" ? <CheckCircleOutlined fontSize="small" /> : <HighlightOffOutlined fontSize="small" />}
            </div>
        </CustomTooltip> :
            <div className={props.data.onbase_confirmation.toLowerCase() === "success" ? "ehr-success" : "ehr-failure"}>
                {props.data.onbase_confirmation.toLowerCase() === "success" ? <CheckCircleOutlined fontSize="small" /> : <HighlightOffOutlined fontSize="small" />}
            </div>
    )
}

const RenderEpicMessage = (props) => {
    return (
        props.data.epic_error_message ? <CustomTooltip title={props.data.epic_error_message} placement="top-start">
            <div className={props.data.epic_confirmation.toLowerCase() === "success" ? "ehr-success" : "ehr-failure"}>
                {props.data.epic_confirmation.toLowerCase() === "success" ? <CheckCircleOutlined fontSize="small" /> : <HighlightOffOutlined fontSize="small" />}
                <div>{props.data.onbase_id}</div>
            </div>
        </CustomTooltip> : <div className={props.data.epic_confirmation.toLowerCase() === "success" ? "ehr-success" : "ehr-failure"}>
            {props.data.epic_confirmation.toLowerCase() === "success" ? <CheckCircleOutlined fontSize="small" /> : <HighlightOffOutlined fontSize="small" />}
            <div>{props.data.onbase_id}</div>
        </div>
    )
}

export {
    RenderOnbaseMessage,
    RenderEpicMessage
}